export const getEnvFromUrl = (url: string): string => {
  if (url.includes('preview')) {
    url = url.slice(9)
  }
  const envs: { [key: string]: string } = {
    'preview.pubstack.io': 'preview',
    'app.dev.pubstack.io': 'dev',
    'app.beta.pubstack.io': 'beta',
    'app.pubstack.io': 'prod',
  }
  return envs[url] ?? 'local'
}

export const isProd = (): boolean => {
  return getEnvFromUrl(window.location.host) === 'prod'
}

// Spark Console is a separate app with its own domain per environment (infra/env/conf.tf). Preview and local
// builds have no console counterpart of their own, so they fall back to dev's.
const SPARK_CONSOLE_DOMAIN: { [env: string]: string } = {
  prod: 'spark.pubstack.io',
  beta: 'spark.beta.pubstack.io',
  dev: 'spark.dev.pubstack.io',
}

export const sparkConsoleUrl = (): string => `https://${SPARK_CONSOLE_DOMAIN[getEnvFromUrl(window.location.host)] ?? SPARK_CONSOLE_DOMAIN.dev}`
